import React from 'react';
import { MessageSquare } from 'lucide-react';

interface StickyHeaderProps {
  visible: boolean;
  onContact: () => void;
}

export function StickyHeader({ visible, onContact }: StickyHeaderProps) {
  return (
    <div className={`fixed top-0 left-0 right-0 bg-white shadow-md transform transition-transform duration-300 z-50 ${
      visible ? 'translate-y-0' : '-translate-y-full'
    }`}>
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-semibold text-gray-900">
              Ready to optimize your HOA's investments?
            </h2>
          </div>
          <button
            onClick={onContact}
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 shadow-sm hover:shadow"
          >
            <MessageSquare className="h-4 w-4" />
            Schedule a Consultation
          </button>
        </div>
      </div>
    </div>
  );
}